import React, { FC } from 'react';

import { GPTGroupObjectType } from '@app/interfaces/gpt-metric.type';

import { GPTAllIntegrationListObjectType } from '@app/interfaces/settings.type';

import {
  AllChanelsArrType,
  MetricListArrType,
  MetricTypesArrType,
} from '@app/interfaces/pages-types/anatylics-metric.type';

import { MetricTemplatesGroupType } from '@app/interfaces/slices-types/metric-templates.type';

import AiMetricChat from '../chat-modals/ai-metric-chat/ai-metric-chat';

import AiMetricVoice from './ai-metric-voice';

type AiMetricPropsType = {
  gptModelsList: GPTAllIntegrationListObjectType | undefined;
  allChannels?: AllChanelsArrType[];
  editModal?: boolean;
  copyModal?: boolean;
  gptModalData: GPTGroupObjectType | undefined;
  modalsSetState: (type: string) => void;
  metric: MetricTypesArrType;
  currentTemplate: 'chat' | 'voice';
  metricList?: MetricListArrType[];
  metricTemplates: MetricTemplatesGroupType[] | undefined;
};

const AiMetric: FC<AiMetricPropsType> = (props) => {
  const {
    currentTemplate,
    gptModelsList,
    allChannels,
    editModal,
    gptModalData,
    modalsSetState,
    copyModal,
    metricList,
    metricTemplates,
    ...rest
  } = props;

  if (currentTemplate === 'chat') {
    return (
      <AiMetricChat
        gptModelsList={gptModelsList}
        editModal={editModal}
        gptModalData={gptModalData}
        modalsSetState={modalsSetState}
        copyModal={copyModal}
        metricList={metricList}
        metricTemplates={metricTemplates}
        currentTemplate={currentTemplate}
        {...rest}
      />
    );
  } else {
    return (
      <AiMetricVoice
        gptModelsList={gptModelsList}
        allChannels={allChannels}
        editModal={editModal}
        gptModalData={gptModalData}
        modalsSetState={modalsSetState}
        copyModal={copyModal}
        metricList={metricList}
        metricTemplates={metricTemplates}
        currentTemplate={currentTemplate}
      />
    );
  }
};
export default AiMetric;
